<template>
  <b-modal
    id="modal-order-view"
    ref="modal"
    v-model="open"
    size="ov-custom"
    centered
    hide-footer
    title="VIEW ORDER DETAILS"
    @hidden="onModalHidden"
  >
    <b-overlay
      :show="modalLoading"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <b-row class="mb-2">
        <b-col>
          <div class="d-flex align-items-center justify-content-lg-center">
            <order-status-banner
              class="status-bar"
              style="width:100%; font-size: 16px"
              :status-key="order.order_current_status.key"
            />
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2 mb-2">
        <b-col
          cols="12"
          lg="4"
          class="mobile-column"
        >
          <b-badge
            :variant="'light-' + order.order_current_status.color"
            class="col-container d-flex justify-content-between align-items-center align-items-lg-start flex-wrap position-relative"
          >
            <div class="flex-column flex-lg-row mb-1 mt-1 mb-lg-0 text-lg-left text-container">
              <div
                class="ml-lg-1 mr-lg-1"
                style="margin-top: 4px;"
              >
                <div class="font-weight-bolder mb-1 sub-title">
                  {{ order.waybill_number }}
                </div>
                <h5
                  v-if="order.shipment_id"
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  Shipment Number: &nbsp; {{ order.shipment_id }}
                </h5>
                <h5
                  v-if="order.nool_shipment_code"
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  NOOL Shipment Code: &nbsp; {{ order.nool_shipment_code }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  Service Type: &nbsp;{{ appliedServiceTypeLabel }}
                </h5>
                <h5
                  v-if="hasDeliveryCharge"
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  Delivery Charge: &nbsp;{{ currency_type }} {{ order.delivery_charge }}
                </h5>
                <h5
                  v-if="appliedRateCardName"
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  Rate Card: &nbsp;{{ appliedRateCardName }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  COD: &nbsp;{{ currency_type }} {{ order.cod }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  Weight: &nbsp;{{ order.weight }}kg
                </h5>
                <h5 class="font-weight-bold font-small-4">
                  Created on: &nbsp;{{ __dateTimeFormatter(order.created_at) }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4 mt-1"
                  style="margin-bottom:3px;"
                >
                  Delivery Attempt: &nbsp;{{ order.delivery_attempts }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-top:9px"
                >
                  {{ order.description ? (order.description.length > 190 ?
                    order.description.substring(0, 190) + '---' : order.description) : 'No description'
                  }}
                </h5>
                <h5 v-if="items.has_feedback">
                  <star-rating
                    :rating="items.rating"
                    :max-rating="5"
                    :star-size="20"
                    :show-rating="false"
                    :read-only="true"
                  />
                </h5>
              </div>
            </div>
            <div class="avatar-container">
              <b-avatar
                :text="'C'"
                size="26"
                :variant="myVariant"
              />
            </div>
          </b-badge>
        </b-col>
        <b-col
          cols="12"
          lg="4"
          class="mobile-column"
        >
          <b-badge
            :variant="'light-' + order.order_current_status.color"
            class="col-container"
          >
            <div class="flex-column flex-lg-row mb-3 mt-1 mb-lg-0 text-lg-left">
              <div
                class="ml-lg-1 mr-lg-1 text-container"
                style="margin-top: 4px;"
              >
                <div class="font-weight-bolder mb-1 sub-title">
                  Merchant Details
                </div>
                <h5
                  class="font-weight-bolder"
                  style="margin-bottom:3px;"
                >
                  {{ order.merchant_business.business_name }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  {{ order.merchant.name }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  {{ order.merchant.ref_no }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4 opacity-0-per d-none d-lg-flex"
                  style="margin-bottom:1px;"
                >
                  {{ order.merchant.ref_no }}
                </h5>
                <h5 class="font-weight-bold font-small-4">
                  Pickup Address: &nbsp;<b>{{ order.merchant_business.pickup_address }}</b>
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  Origin City: &nbsp;<b>{{ order.origin_city.name }}</b>
                </h5>
                <h5 class="font-weight-bold font-small-4">
                  Origin Warehouse: &nbsp;<b>{{ order.origin_warehouse.name }}</b>
                </h5>
              </div>
            </div>
          </b-badge>
        </b-col>
        <b-col
          cols="12"
          lg="4"
          class="mobile-column"
        >
          <b-badge
            :variant="'light-' + order.order_current_status.color"
            class="col-container"
          >
            <div class="flex-column flex-lg-row mb-3 mt-1 mb-lg-0 text-lg-left">
              <div
                class="ml-lg-1 mr-lg-1 text-container"
                style="margin-top: 4px;"
              >
                <div class="font-weight-bolder mb-1 sub-title">
                  Customer Details
                </div>
                <h5
                  class="font-weight-bolder"
                  style="margin-bottom:3px;"
                >
                  {{ getCustomerFieldValue('customer_name') }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  {{ getCustomerFieldValue('customer_address') }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  {{ getCustomerFieldValue('customer_email') }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  {{ getCustomerFieldValue('customer_phone') }}
                </h5>
                <h5
                  v-if="shouldShowSecondaryPhone"
                  class="font-weight-bold font-small-4"
                  style="margin-bottom:3px;"
                >
                  {{ getCustomerFieldValue('customer_secondary_phone') }}
                </h5>
                <h5
                  class="font-weight-bold font-small-4 mt-1"
                  style="margin-bottom:3px;"
                >
                  Destination City: &nbsp;<b>{{ order.destination_city.name }}</b>
                </h5>
                <h5 class="font-weight-bold font-small-4">
                  Destination Warehouse: &nbsp;<b>{{ order.destination_warehouse.name }}</b>
                </h5>
              </div>
              <div
                v-if="order && order.temporary_warehouse && order.temporary_warehouse.name && order.temporary_warehouse.name.trim() !== ''"
                class="font-weight-bold font-small-4 ml-1"
              >
                Temporary Warehouse: &nbsp;<b>{{ order.temporary_warehouse.name }}</b>
              </div>
            </div>
          </b-badge>
        </b-col>
      </b-row>
      <b-row class="mx-2 mt-2 mb-2">
        <b-col class="d-flex justify-content-lg-end ml-1 ml-lg-0">
          <div
            v-for="flag_type in order.order_flags"
            :key="flag_type.id"
          >
            <b-badge :variant="getFlagBadgeColor((flag_type.order_flag && flag_type.order_flag.type) || flag_type.type || null)">
              {{ (flag_type.order_flag && flag_type.order_flag.name) || flag_type.name || 'Unknown Flag' }}
            </b-badge>
          </div>
        </b-col>
      </b-row>

      <b-tabs
        v-model="activeTab"
        content-class="pt-1 min-height-59vh"
        fill
      >
        <b-tab
          title="Order History"
          class="p-2"
        >
          <app-timeline>
            <app-timeline-item
              v-for="(data, index) in timelineData"
              :key="index"
              :variant="data.status.color ? data.status.color : 'primary'"
              :icon="data.status.icon"
            >
              <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
                <b-badge
                  :variant="data.status.color ? data.status.color : 'primary'"
                  class="mb-2 mobile-column"
                >
                  <div class="text-center">
                    <h6 class="mb-0 text-sm text-wrap">
                      {{ data.status.name }}
                    </h6>
                  </div>
                </b-badge>
                <div class="date-container">
                  <div class="date-formats">
                    {{ __dateTimeFormatter(data.date_time) }}
                  </div>
                  <div class="date-formats">
                    {{ data.date_time_ago }}
                  </div>
                </div>
              </div>

              <p>{{ data.reason || '' }}</p>
              <div v-if="(index == '0' && order.rider_signature != '')">
                <b-button
                  v-if="order.order_current_status.key == 'key_7' || order.order_current_status.key == 'key_13' || order.order_current_status.key == 'key_14'"
                  variant="outline-primary"
                  size="sm"
                  class="view-sign-button"
                  @click="openSignatureModal()"
                >
                  View Signature
                </b-button>
              </div>
              <div v-if="(shouldShowProofBtn(data))">
                <b-button
                  variant="outline-primary"
                  size="sm"
                  class="btn mb-1 btn-outline-primary btn-sm"
                  @click="openProofDocModal(data.proofs)"
                >
                  View Proof Images
                </b-button>
              </div>
              <div class="d-flex flex-sm-row flex-column justify-content-between align-items-start">
                <b-media>
                  <template #aside>
                    <b-avatar
                      :src="`https://picsum.photos/200/200?random=${index}`"
                      class="mr-30"
                      variant="light-success"
                    />
                  </template>
                  <h5>{{ data.user.first_name || '' }} {{ data.user.last_name || '' }}</h5>
                  <h6>{{ data.user.reference_id || '' }}</h6>
                  <span>{{ data.user_role || '' }}</span>
                </b-media>
              </div>
            </app-timeline-item>
          </app-timeline>
        </b-tab>
        <b-tab
          title="Rider Deposit History"
          class="px-2"
          @click="getOrderFinanceTimeline()"
        >
          <app-timeline v-if="financeTimelineData.staff_deposit">
            <div
              class="shadow rounded-sm mb-3 w-100 bg-light-secondary"
              style="padding:10px;"
            >
              <div class="font-small-5 font-weight-bold text-center text-dark">
                Ref No : {{ financeTimelineData.staff_deposit[0].ref_no }}
              </div>
            </div>
            <app-timeline-item
              v-for="(data, index) in financeTimelineData.staff_deposit"
              :key="index"
              :variant="'light-' + data.status.color ? data.status.color : 'primary'"
              :icon="data.status.icon"
            >
              <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
                <h6>{{ data.status.name }}</h6>
                <small class="text-muted">{{ __dateTimeFormatter(data.date_time) }} | {{
                  data.date_time_ago }}</small>
              </div>
              <h5 class="font-small-3">
                {{ data.deposit_amount }}
              </h5>
              <p>{{ data.reason || '' }}</p>
              <div
                v-if="data.user !== 'Automatically Generated'"
                class="d-flex flex-sm-row flex-column justify-content-between align-items-start"
              >
                <b-media>
                  <template #aside>
                    <b-avatar
                      :src="`https://picsum.photos/200/200?random=${index}`"
                      class="mr-30"
                      variant="light-success"
                    />
                  </template>
                  <h6>{{ data.user.first_name || '' }} {{ data.user.last_name || '' }}</h6>
                  <h6>{{ data.user.reference_id || '' }}</h6>
                  <span class="text-muted">{{ data.user_role || '' }}</span>
                </b-media>
              </div>
              <h6
                v-else
                class="font-weight-bolder"
              >
                {{ data.user }}
              </h6>
            </app-timeline-item>
          </app-timeline>
          <div
            v-else
            class="d-flex justify-content-center align-items-center"
          >
            This order has no recorded staff deposit history
          </div>
        </b-tab>
        <b-tab
          title="Warehouse Deposit History"
          class="px-2"
          @click="getOrderFinanceTimeline()"
        >
          <app-timeline
            v-if="financeTimelineData.warehouse_deposit || financeTimelineData.walking_warehouse_deposit"
          >
            <b-row>
              <b-col
                v-if="isWalkingDeposit"
                :cols="financeTimelineData.warehouse_deposit ? 6 : 12"
              >
                <div
                  class="shadow rounded-sm mb-3 w-100 bg-light-secondary"
                  style="padding:10px;"
                >
                  <div class="font-small-5 font-weight-bold text-center text-dark">
                    Advance Deposit - Ref No : {{
                      financeTimelineData.walking_warehouse_deposit[0].ref_no }}
                  </div>
                </div>
                <app-timeline-item
                  v-for="(data, index) in financeTimelineData.walking_warehouse_deposit"
                  :key="index"
                  :variant="'light-' + data.status.color ? data.status.color : 'primary'"
                  :icon="data.status.icon"
                >
                  <div
                    class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
                  >
                    <div>
                      <h6>{{ data.status.name }}</h6>
                      <h5 class="font-small-3">
                        {{ data.deposit_amount }}
                      </h5>
                    </div>
                    <small class="text-muted">{{ __dateTimeFormatter(data.date_time) }} | {{
                      data.date_time_ago
                    }}</small>
                  </div>
                  <p>{{ data.reason || '' }}</p>
                  <div
                    v-if="data.user !== 'Automatically Generated'"
                    class="d-flex flex-sm-row flex-column justify-content-between align-items-start"
                  >
                    <b-media>
                      <template #aside>
                        <b-avatar
                          :src="`https://picsum.photos/200/200?random=${index}`"
                          class="mr-30"
                          variant="light-success"
                        />
                      </template>
                      <h6>{{ data.user.first_name || '' }} {{ data.user.last_name || '' }}</h6>
                      <h6>{{ data.user.reference_id || '' }}</h6>
                      <span class="text-muted">{{ data.user_role || '' }}</span>
                    </b-media>
                  </div>
                  <h6
                    v-else
                    class="font-weight-bolder"
                  >
                    {{ data.user }}
                  </h6>
                </app-timeline-item>
              </b-col>
              <b-col
                v-if="financeTimelineData.warehouse_deposit"
                :cols="isWalkingDeposit ? 6 : 12"
              >
                <div
                  class="shadow rounded-sm mb-3 w-100 bg-light-secondary"
                  style="padding:10px;"
                >
                  <div class="font-small-5 font-weight-bold text-center text-dark">
                    Balance Deposit - Ref No : {{ financeTimelineData.warehouse_deposit[0].ref_no }}
                  </div>
                </div>
                <app-timeline-item
                  v-for="(data, index) in financeTimelineData.warehouse_deposit"
                  :key="index"
                  :variant="'light-' + data.status.color ? data.status.color : 'primary'"
                  :icon="data.status.icon"
                >
                  <div
                    class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
                  >
                    <div>
                      <h6>{{ data.status.name }}</h6>
                      <h5 class="font-small-3">
                        {{ data.deposit_amount }}
                      </h5>
                    </div>
                    <small class="text-muted">{{ __dateTimeFormatter(data.date_time) }} | {{
                      data.date_time_ago
                    }}</small>
                  </div>
                  <p>{{ data.reason || '' }}</p>
                  <div
                    v-if="data.user !== 'Automatically Generated'"
                    class="d-flex flex-sm-row flex-column justify-content-between align-items-start"
                  >
                    <b-media>
                      <template #aside>
                        <b-avatar
                          :src="`https://picsum.photos/200/200?random=${index}`"
                          class="mr-30"
                          variant="light-success"
                        />
                      </template>
                      <h6>{{ data.user.first_name || '' }} {{ data.user.last_name || '' }}</h6>
                      <h6>{{ data.user.reference_id || '' }}</h6>
                      <span class="text-muted">{{ data.user_role || '' }}</span>
                    </b-media>
                  </div>
                  <h6
                    v-else
                    class="font-weight-bolder"
                  >
                    {{ data.user }}
                  </h6>
                </app-timeline-item>
              </b-col>
            </b-row>
          </app-timeline>
          <div
            v-else
            class="d-flex justify-content-center align-items-center"
          >
            This order has no recorded warehouse deposit history
          </div>
        </b-tab>
        <b-tab
          title="Invoice History"
          class="px-2"
          @click="getOrderInvoiceTimeline()"
        >
          <app-timeline v-if="invoiceTimelineData.length > 0">
            <div
              class="shadow rounded-sm mb-3 w-100 bg-light-secondary"
              style="padding:10px;"
            >
              <div class="font-small-5 font-weight-bold text-center text-dark">
                Invoice No : {{ invoiceTimelineData[0].invoice_no }}
              </div>
            </div>
            <app-timeline-item
              v-for="(data, index) in invoiceTimelineData"
              :key="index"
              :variant="'light-' + data.status.color ? data.status.color : 'primary'"
              :icon="data.status.icon"
            >
              <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
                <div>
                  <h6>{{ data.status.name }}</h6>
                  <h5 class="font-small-3">
                    {{ data.invoice_amount }}
                  </h5>
                </div>
                <small class="text-muted">{{ __dateTimeFormatter(data.date_time) }} | {{
                  data.date_time_ago }}</small>
              </div>
              <p>{{ data.reason || '' }}</p>
              <div
                v-if="data.user !== 'Automatically Generated'"
                class="d-flex flex-sm-row flex-column justify-content-between align-items-start"
              >
                <b-media>
                  <template #aside>
                    <b-avatar
                      :src="`https://picsum.photos/200/200?random=${index}`"
                      class="mr-30"
                      variant="light-success"
                    />
                  </template>
                  <h6>{{ data.user.first_name || '' }} {{ data.user.last_name || '' }}</h6>
                  <h6>{{ data.user.reference_id || '' }}</h6>
                  <span class="text-muted">{{ data.user_role || '' }}</span>
                </b-media>
              </div>
              <h6
                v-else
                class="font-weight-bolder"
              >
                {{ data.user }}
              </h6>
            </app-timeline-item>
          </app-timeline>
          <div
            v-else
            class="d-flex justify-content-center align-items-center"
          >
            This order has no recorded Invoice history
          </div>
        </b-tab>
        <b-tab
          :title="`General Remarks (${remarksCount})`"
          @click="getOrderRemarkTimeLine()"
        >
          <div v-if="order.remark && order.remark.length">
            <remark-table
              :remarks="order.remark"
              :order-id="id"
            />
          </div>
          <div
            v-else
            class="d-flex justify-content-center align-items-center"
          >
            This order has no remarks
          </div>
        </b-tab>
        <b-tab
          v-if="order.is_reversed_order === true"
          v-can="'view-reversal'"
          title="Reversed Details"
        >
          <reversed-details :order_id="id" />
        </b-tab>
        <b-tab
          v-if="order.order_flags && order.order_flags.length > 0"
          title="Flag History"
          @click="getOrderFlagTimeLine()"
        >
          <flag-details :flag_data="flagTimelineData" />
        </b-tab>
        <b-tab
          title="Sorting History"
          class="p-2"
          @click="getOrderSortingTimeline()"
        >
          <app-timeline v-if="sortingTimelineData.length > 0">
            <app-timeline-item
              v-for="(data, index) in sortingTimelineData"
              :key="index"
              :color="data.bucket.color ? data.bucket.color : '#007bff'"
              :icon="'TrendingUpIcon'"
            >
              <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
                <b-badge
                  :style="{
                    backgroundColor: data.bucket.color,
                  }"
                  class="mb-2 mobile-column"
                >
                  <div class="text-center">
                    <h6 class="mb-0 text-sm text-wrap text-white">
                      {{ data.bucket.name }}
                    </h6>
                  </div>
                </b-badge>
                <div class="date-container">
                  <div class="date-formats">
                    {{ __dateTimeFormatter(data.date_time) }}
                  </div>
                  <div class="date-formats">
                    {{ data.date_time_ago }}
                  </div>
                </div>
              </div>

              <p>{{ data.sorting_id_string || '' }}</p>
              <div class="d-flex flex-sm-row flex-column justify-content-between align-items-start">
                <b-media>
                  <template #aside>
                    <b-avatar
                      :src="`https://picsum.photos/200/200?random=${index}`"
                      class="mr-30"
                      variant="light-success"
                    />
                  </template>
                  <h5>{{ data.user.first_name || '' }} {{ data.user.last_name || '' }}</h5>
                  <h6>{{ data.user.reference_id || '' }}</h6>
                  <span>{{ data.user_role || '' }}</span>
                </b-media>
              </div>
            </app-timeline-item>
          </app-timeline>
          <div
            v-else
            class="d-flex justify-content-center align-items-center"
          >
            This order has no recorded sorting history
          </div>
        </b-tab>
        <b-tab
          title="Edit Log History"
          @click="getOrderEditLogTimeline()"
        >
          <div>
            <order-edit-logs :edit_log_data="editLogTimelineData" />
          </div>
        </b-tab>
        <b-tab
          v-if="shouldShowStatusChangeTab"
          title="Status Change"
          class="p-2"
          @click="fetchAfterStatuses"
        >
          <div
            v-if="afterStatusesLoading"
            class="d-flex justify-content-center align-items-center"
            style="min-height: 200px;"
          >
            <b-spinner
              variant="primary"
              label="Loading..."
            />
          </div>
          <div v-else-if="afterStatuses.length > 0">
            <b-row class="justify-content-start">
              <b-col
                v-for="status in afterStatuses"
                :key="status.key"
                cols="12"
                md="4"
                class="mb-1"
              >
                <div
                  :style="{ backgroundColor: getStatusButtonVariant(status.color) + 20 }"
                  class="d-flex justify-content-start align-items-center status-button"
                  @click="onStatusChangeClick(status)"
                >
                  <div
                    :style="{ backgroundColor: getStatusButtonVariant(status.color) }"
                    class="mr-1 status-button-icon-container"
                  >
                    <feather-icon
                      :icon="status.icon"
                      size="30"
                      style="color: white; padding: 0.4rem 0.2rem;"
                    />
                  </div>
                  <span
                    :style="{ color: getStatusButtonVariant(status.color) }"
                    class="status-button-text"
                  >
                    {{ status.name }}
                  </span>
                </div>
              </b-col>
            </b-row>
          </div>
          <div
            v-else
            class="d-flex justify-content-center align-items-center"
            style="min-height: 200px;"
          >
            <p class="text-muted mb-0">
              No status change options available for this order
            </p>
          </div>
          <b-row
            v-if="formStructure.length > 0"
            class="mt-2"
          >
            <b-col>
              <form-builder
                ref="formbuilder"
                v-model="formData"
                :on-submit="onSubmit"
                grid-class="px-1 row"
                :form-structure="formStructure"
                @suggested_city_idOnChanged="handleCityChange"
                @warehouse_idOnChanged="onWarehouseChange"
              >
                <template slot="buttons">
                  <b-row>
                    <b-col>
                      <b-button
                        type="submit"
                        class="vh-5 mt-2"
                        variant="primary"
                        :disabled="modalLoading"
                      >
                        {{ modalLoading ? 'Submitting...' : 'Submit' }}
                      </b-button>
                    </b-col>
                  </b-row>
                </template>
              </form-builder>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>

    </b-overlay>
    <b-modal
      id="signature-view"
      v-model="signatureOpen"
      size="sm"
      centered
      hide-footer
      title="VIEW SIGNATURE"
    >
      <div class="signature-container">

        <img
          :src="`${cdn}${order.rider_signature}`"
          alt="Rider's Signature"
          class="signature"
        >
        <!-- <b-button
          class="signature-button"
          variant="outline-primary"
          size="sm"
          @click="downloadImg(`${cdn}${order.rider_signature}`, `${order.waybill_number}`)"
        >Download</b-button> -->
      </div>
    </b-modal>
    <b-modal
      id="proof-doc-open-view"
      v-model="proofDocOpen"
      size="lg"
      centered
      hide-footer
      title="VIEW PROOF IMAGES"
    >
      <div>
        <b-row>
          <b-col
            v-for="(p, i) in selectedProofs"
            :key="p.id || i"
            cols="6"
            class="mb-2"
          >
            <img
              :src="p.url"
              alt="Proof"
              class="proof-image"
            >
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </b-modal>
</template>

<script>
import {
  BModal,
  BOverlay,
  VBModal,
  BTabs,
  BTab,
  BAvatar,
  BRow,
  BCol,
  BBadge,
  BMedia,
  BButton,
  BSpinner,
} from 'bootstrap-vue'
import OrderStatusBanner from '@core/components/status/OrderStatusBanner.vue'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import displayAmountWithCurrency from '@core/mixins/currency'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import ReversedDetails from '@/components/AllOrders/reversedDetails.vue'
import FlagDetails from '@/components/AllOrders/FlagHistoryDetails.vue'
import RemarkTable from '@/components/AllOrders/Remark/RemarkTable.vue'
import FormBuilder from '@/libs/builders/form-builder/FormBuilder.vue'
import loadStatusFlowComponent from '@/components/status-flow/loadStatusFlowComponent'
import { avatarText } from '@core/utils/filter'
import emptyOrderPayload from '@/models/order'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import StarRating from 'vue-star-rating'
import OrderEditLogs from '@/components/AllOrders/OrderEditLogs.vue'
import { appliedServiceTypeLabel as formatAppliedServiceType } from '@/helpers/serviceTypeFeature'

const OrderRepository = RepositoryFactory.get('order')
const ResourceRepository = RepositoryFactory.get('resource')
const feedBackRepository = RepositoryFactory.get('feedback')
const StatusSettingsRepository = RepositoryFactory.get('statusSetting')
const OrderSettingsRepository = RepositoryFactory.get('orderSetting')

export default {
  name: 'OperationViewOrderModal',
  directives: {
    'b-modal': VBModal,
  },
  components: {
    BModal,
    BOverlay,
    BTabs,
    BTab,
    BAvatar,
    BRow,
    BCol,
    BBadge,
    BMedia,
    BButton,
    BSpinner,
    StarRating,
    OrderStatusBanner,
    AppTimeline,
    AppTimelineItem,
    ReversedDetails,
    RemarkTable,
    FlagDetails,
    FormBuilder,
    OrderEditLogs,
  },
  mixins: [SuccessMessage, ErrorMessage, displayAmountWithCurrency],
  data() {
    return {
      avatarText,
      open: false,
      signatureOpen: false,
      modalLoading: false,
      isWalkingDeposit: false,
      id: null,
      items: {},
      perPage: 10,
      timelineData: [],
      financeTimelineData: [],
      invoiceTimelineData: [],
      sortingTimelineData: [],
      flagTimelineData: [],
      remarksCount: 0,
      loadingRemarks: false,
      order: emptyOrderPayload(),
      fields: [
        { key: 'remarkedBy', label: 'Remarked By', sortable: true },
        { key: 'remark', label: 'Remark', sortable: false },
        { key: 'created_at', label: 'Remark Date', sortable: false },
      ],
      cdn: process.env.VUE_APP_BUCKET_URL,
      myVariant: '',
      proofDocOpen: false,
      selectedProofs: [],
      afterStatuses: [],
      afterStatusesLoading: false,
      isQuickStatusUpdateEnabled: false,
      formData: {},
      orderSettings: {},
      errors: [],
      formStructure: [],
      nextStatusKey: '',
      editLogTimelineData: [],
      activeTab: 0,
      shouldOpenStatusChangeTab: false,
      cityOptions: [],
    }
  },
  computed: {
    shouldShowStatusChangeTab() {
      return this.isQuickStatusUpdateEnabled && this.$can('edit-quick-status-update')
    },
    shouldShowSecondaryPhone() {
      // Check if secondary phone exists in order data
      return this.order.customer_secondary_phone !== null && this.order.customer_secondary_phone !== undefined && this.order.customer_secondary_phone !== ''
    },
    appliedServiceTypeLabel() {
      return formatAppliedServiceType(this.order && this.order.applied_service_type)
    },
    hasDeliveryCharge() {
      return this.order && this.order.delivery_charge !== null && this.order.delivery_charge !== undefined && this.order.delivery_charge !== ''
    },
    appliedRateCardName() {
      return this.order && this.order.applied_rate_card && this.order.applied_rate_card.card_name
        ? this.order.applied_rate_card.card_name
        : ''
    },
  },
  methods: {
    async fetchFeedbackDetails() {
      try {
        const { data } = (await feedBackRepository.getFeedbackDetails(this.id)).data
        this.items = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async openModal(id, options = {}) {
      this.open = true
      this.id = id
      this.modalLoading = true
      this.shouldOpenStatusChangeTab = options.openStatusChangeTab || false

      this.remarksCount = 0
      this.flagTimelineData = []
      await this.fetchOrderDetails()
      await this.getOrderTimeline()
      await this.fetchFeedbackDetails()
      await this.fetchQuickStatusUpdateSetting()
      await this.readOrderSetting()
      this.modalLoading = false

      // Wait for next tick to ensure tabs are rendered
      await this.$nextTick()

      // If status change tab was requested and should be shown
      if (this.shouldOpenStatusChangeTab && this.shouldShowStatusChangeTab) {
        // Calculate the status change tab index based on conditional tabs
        let tabIndex = 5 // Base tabs: Order History(0), Rider Deposit(1), Warehouse Deposit(2), Invoice(3), General Remarks(4)

        // Add 1 if Reversed Details tab is shown
        if (this.order.is_reversed_order === true) {
          tabIndex += 1
        }

        // Add 1 if Flag History tab is shown
        if (this.order.order_flags && this.order.order_flags.length > 0) {
          tabIndex += 1
        }

        // Add 1 for Sorting History
        tabIndex += 1

        // Add 1 for Edit Log History
        tabIndex += 1

        // Now tabIndex points to Status Change tab
        this.activeTab = tabIndex

        // Fetch the after statuses
        await this.fetchAfterStatuses()
      } else {
        this.activeTab = 0
      }
    },
    openSignatureModal() {
      this.signatureOpen = true
    },
    openProofDocModal(proofs) {
      this.selectedProofs = proofs
      this.proofDocOpen = true
    },
    async getOrderTimeline() {
      try {
        const { data } = await OrderRepository.getOrderTimeLine(this.id)
        this.timelineData = (data.data || []).map(item => ({
          ...item,
          proofs: Array.isArray(item.proofs) ? item.proofs : [],
        }))
      } catch (e) {
        this.timelineData = []
      }
    },
    async getOrderFinanceTimeline() {
      try {
        const { data } = await OrderRepository.getOrderFinanceTimeLine(this.id)
        this.financeTimelineData = data.data
        if (this.financeTimelineData.walking_warehouse_deposit) {
          if ((this.financeTimelineData.walking_warehouse_deposit).length > 0) {
            this.isWalkingDeposit = true
            this.financeTimelineData.walking_warehouse_deposit.push(this.getStatusCopy(data.data.walking_warehouse_deposit.slice().pop()))
          }
        }
        if (this.financeTimelineData.staff_deposit) {
          if (this.financeTimelineData.staff_deposit.length > 0) {
            this.financeTimelineData.staff_deposit.push(this.getStatusCopy(data.data.staff_deposit.slice().pop()))
          }
        }
        if (this.financeTimelineData.warehouse_deposit) {
          if (this.financeTimelineData.warehouse_deposit.length > 0) {
            this.financeTimelineData.warehouse_deposit.push(this.getStatusCopy(data.data.warehouse_deposit.slice().pop()))
          }
        }
      } catch (e) {
        this.financeTimelineData = []
      }
    },
    async getOrderInvoiceTimeline() {
      try {
        const { data } = await OrderRepository.getOrderInvoiceTimeLine(this.id)
        this.invoiceTimelineData = data.data
        if (this.invoiceTimelineData.length > 0) {
          this.invoiceTimelineData.push(this.getStatusCopy(data.data.slice().pop()))
        }
      } catch (e) {
        this.invoiceTimelineData = []
      }
    },
    async getOrderSortingTimeline() {
      try {
        const { data } = await OrderRepository.getOrderSortingTimeline(this.id)
        this.sortingTimelineData = data.data
      } catch (e) {
        this.sortingTimelineData = []
      }
    },
    async fetchOrderDetails() {
      try {
        const { data } = (await OrderRepository.fetchOrderDetailsById(this.id)).data
        this.order = data
        this.myVariant = this.order.order_current_status.color
        this.remarksCount = data.remark || 0
        this.$set(this.order, 'remark', [])
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getOrderRemarkTimeLine() {
      this.loadingRemarks = true
      try {
        const { data } = await OrderRepository.getOrderRemarkTimeLine(this.id)
        this.$set(this.order, 'remark', data.remark)
      } catch (e) {
        this.order.remark = []
      } finally {
        this.loadingRemarks = false
      }
    },
    async getOrderFlagTimeLine() {
      try {
        const { data } = await OrderRepository.getOrderFlagTimeLine(this.id)
        this.flagTimelineData = data.order_flags
      } catch (e) {
        this.flagTimelineData = []
      }
    },
    getCustomerFieldValue(fieldName) {
      // If order is encrypted
      if (this.order.is_encrypted) {
        // If user has permission to view decrypted data, show real values
        if (this.$can('show-decrypted-orders')) {
          // API returns decrypted data when user has permission, so show real value
          return this.order[fieldName] || ''
        }
        // User doesn't have permission - show masked
        return '******'
      }

      // Order is not encrypted - show normal data
      return this.order[fieldName] || ''
    },
    getFlagBadgeColor(type) {
      if (type === 'flag_1') {
        return 'light-info'
      }
      if (type === 'flag_2') {
        return 'light-danger'
      }
      if (type === 'flag_3') {
        return 'light-primary'
      }
      if (type === 'flag_4') {
        return 'light-dark'
      }
      if (type === 'flag_5') {
        return 'light-success'
      }
      if (type === 'flag_6') {
        return 'light-warning'
      }
      if (type === 'flag_7') {
        return 'light-danger'
      }
      if (type === 'flag_8') {
        return 'light-info'
      }
      return 'light-primary'
    },
    getStatusCopy(status) {
      const pendingCopy = JSON.parse(JSON.stringify(status))
      pendingCopy.status.name = 'Created'
      pendingCopy.status.color = 'success'
      return pendingCopy
    },
    downloadImg(urlFromFunction, wayBillNumber) {
      const xhr = new XMLHttpRequest()
      const fileName = `${wayBillNumber}_customer_signature.png`
      const dataType = 'png'
      xhr.onload = function c() {
        const arr = new Uint8Array(this.response)
        const raw = String.fromCharCode.apply(null, arr)
        const b64 = btoa(raw)
        const dataURL = `data:image/${dataType};base64,${b64}`
        const element = document.createElement('a')
        element.href = dataURL
        element.setAttribute('download', fileName)
        document.body.appendChild(element)
        element.click()
        element.remove()
      }
      xhr.open('GET', urlFromFunction)
      xhr.responseType = 'arraybuffer'
      xhr.send()
    },
    shouldShowProofBtn(data) {
      const allowed = ['key_6', 'key_7', 'key_13', 'key_14', 'key_15']
      return Array.isArray(data.proofs) && data.proofs.length > 0 && allowed.includes(data.status?.key)
    },
    async fetchQuickStatusUpdateSetting() {
      try {
        const { data } = (await StatusSettingsRepository.getStatusSettings()).data
        this.isQuickStatusUpdateEnabled = data.quick_status_update.enabled
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async readOrderSetting() {
      try {
        this.orderSettings = localStorage.getItem('order_setting') ? JSON.parse(localStorage.getItem('order_setting')) : (await OrderSettingsRepository.getOrderSettingsResource()).data.data
        if (!localStorage.getItem('order_setting')) localStorage.setItem('order_setting', JSON.stringify(this.orderSettings))
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getCityList() {
      try {
        const cityOptions = localStorage.getItem('city_list') ? JSON.parse(localStorage.getItem('city_list')) : (await ResourceRepository.getCityDropdownListNoFilter(this.search)).data.data
        if (!localStorage.getItem('city_list')) localStorage.setItem('city_list', JSON.stringify(cityOptions))
        return cityOptions
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    async fetchAfterStatuses() {
      try {
        this.afterStatusesLoading = true
        const { data } = await OrderRepository.getOrderAfterStatuses(this.order.order_current_status.key)
        this.afterStatuses = data.data || []
      } catch (e) {
        this.afterStatuses = []
        this.convertAndNotifyError(e)
      } finally {
        this.afterStatusesLoading = false
      }
    },
    getStatusButtonVariant(color) {
      // Convert color to Bootstrap variant or return outline variant
      const colorMap = {
        primary: '#007bff',
        info: '#17a2b8',
        danger: '#dc3545',
        success: '#28a745',
        warning: '#ffc107',
        secondary: '#6c757d',
      }
      return colorMap[color] || '#007bff'
    },
    async onStatusChangeClick(status) {
      try {
        this.modalLoading = true
        this.formStructure = []
        this.formData = {}
        this.nextStatusKey = status.key

        await this.$nextTick()

        // Define the status keys that use KeyCommon form structure
        const commonStatusKeys = ['key_3', 'key_6', 'key_8', 'key_11', 'key_13', 'key_18', 'key_19', 'key_20', 'key_22', 'key_23', 'key_24', 'key_27', 'key_32', 'key_34']

        // Check if the clicked status key is in the KeyCommon list
        if (commonStatusKeys.includes(this.nextStatusKey)) {
          // Set the formStructure from KeyCommon
          const KeyCommon = await loadStatusFlowComponent('KeyCommon')
          this.formStructure = KeyCommon.data().formStructure
        } else {
          // Handle other status keys from key_4 to key_35
          switch (this.nextStatusKey) {
            case 'key_4':
              this.formStructure = (await loadStatusFlowComponent('KeyFour')).data().formStructure
              break
            case 'key_5':
              this.formStructure = (await loadStatusFlowComponent('KeyFive')).data().formStructure
              break
            case 'key_7':
              this.formStructure = (await loadStatusFlowComponent('KeySeven')).data().formStructure
              break
            case 'key_9':
              this.formStructure = (await loadStatusFlowComponent('KeyNine')).data().formStructure
              break
            case 'key_10': {
              const KeyTen = await loadStatusFlowComponent('KeyTen')
              this.formStructure = this.orderSettings.truck_driver_enabled
                ? KeyTen.data().formStructure
                : KeyTen.data().formStructure.slice(0, 3)
              break
            }
            case 'key_12':
              this.formStructure = (await loadStatusFlowComponent('KeyTwelve')).data().formStructure
              break
            case 'key_14': {
              const KeyFourteen = await loadStatusFlowComponent('KeyFourteen')
              const reasonOptions = await KeyFourteen.methods.formStructureForAllOrders()
              this.formStructure = KeyFourteen.data().formStructure
              this.formStructure[2].options = reasonOptions
              this.formData.collected_cod = this.order.cod
              break
            }
            case 'key_15': {
              const KeyFifteen = await loadStatusFlowComponent('KeyFifteen')
              const reasonOptions = await KeyFifteen.methods.formStructureForAllOrders()
              this.formStructure = KeyFifteen.data().formStructure
              this.formStructure[1].options = reasonOptions
              break
            }
            case 'key_16':
              this.formStructure = (await loadStatusFlowComponent('KeySixteen')).data().formStructure
              break
            case 'key_17': {
              const KeySeventeen = await loadStatusFlowComponent('KeySeventeen')
              const reasonOptions = await KeySeventeen.methods.formStructureForAllOrders()
              this.formStructure = KeySeventeen.data().formStructure
              this.formStructure[1].options = reasonOptions
              break
            }
            case 'key_25':
              this.formStructure = (await loadStatusFlowComponent('KeyTwentyFive')).data().formStructure
              break
            case 'key_26':
              this.formStructure = (await loadStatusFlowComponent('KeyTwentySix')).data().formStructure
              break
            case 'key_28':
              this.formStructure = (await loadStatusFlowComponent('KeyTwentyEight')).data().formStructure
              break
            case 'key_29':
              this.formStructure = (await loadStatusFlowComponent('KeyTwentyEight')).data().formStructure
              break
            case 'key_30':
              this.formStructure = (await loadStatusFlowComponent('KeyThirty')).data().formStructure
              break
            case 'key_31': {
              const KeyThirtyOne = await loadStatusFlowComponent('KeyThirtyOne')
              const reasonOptions = await KeyThirtyOne.methods.formStructureForAllOrders()
              this.formStructure = KeyThirtyOne.data().formStructure
              this.formStructure[1].options = reasonOptions
              break
            }
            case 'key_33':
              this.formStructure = (await loadStatusFlowComponent('KeyThirtyThree')).data().formStructure
              break
            case 'key_35':
              this.formStructure = (await loadStatusFlowComponent('KeyThirtyFive')).data().formStructure
              break
            default: {
              const KeyCustom = await loadStatusFlowComponent('KeyCustom')
              this.formStructure = KeyCustom.methods.staticFormStructure(status.actions)
            }
          }
        }
        // Set waybill_number in formData if formStructure is not empty
        if (this.formStructure.length > 0) {
          this.formData.waybill_number = this.order.waybill_number
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      } finally {
        this.modalLoading = false
      }
    },
    handleCityChange(cityId) {
      if (this.nextStatusKey === 'key_26') {
        this.keyTwentySixCityChange(cityId)
      }
      if (this.nextStatusKey === 'key_28' || this.nextStatusKey === 'key_29') {
        this.keyTwentyEightOrTwentyNineCityChange(cityId)
      }
    },
    keyTwentySixCityChange(cityId) {
      const cityField = this.formStructure.find(f => f.value === 'suggested_city_id')
      if (!cityField || !cityField.options) return

      // Find the selected city option
      const selectedCity = cityField.options.find(opt => opt.value === cityId)

      if (selectedCity) {
        // Update the warehouse fields first
        this.$set(this.formData, 'suggested_warehouse_id', selectedCity.default_warehouse?.id || '')
        this.$set(this.formData, 'suggested_warehouse', selectedCity.default_warehouse?.name || '')
      } else {
        // Clear all fields if no city selected
        this.$set(this.formData, 'suggested_warehouse_id', '')
        this.$set(this.formData, 'suggested_warehouse', '')
      }
    },
    async keyTwentyEightOrTwentyNineCityChange(cityId) {
      const warehouseOptions = (await ResourceRepository.getWarehouseByCity(cityId)).data.data
      const warehouseFormIndex = this.formStructure.findIndex(field => field.value === 'suggested_warehouse_id')

      if (warehouseFormIndex !== -1) {
        this.updateDropdownOptions('suggested_warehouse_id', warehouseOptions || [])
        const cityOptions = await this.getCityList()
        if (cityOptions.length > 0) {
          const selectedCity = cityOptions.find(opt => opt.id === cityId)
          if (selectedCity && selectedCity.default_warehouse_id) {
            this.$set(this.formData, 'suggested_warehouse_id', selectedCity.default_warehouse_id)
          }
        }
      }
    },
    async onWarehouseChange(warehouseId) {
      if (warehouseId) {
        // Load cities based on selected warehouse
        this.cityOptions = await this.getCityListByWarehouse(warehouseId)

        // Update the formStructure city dropdown fetchData with filtered cities and enable it
        const cityFormIndex = this.formStructure.findIndex(field => field.value === 'destination_city_id')
        if (cityFormIndex !== -1) {
          this.$set(this.formStructure[cityFormIndex], 'fetchData', this.cityOptions)
          this.$set(this.formStructure[cityFormIndex], 'disabled', false) // Enable city dropdown
          // Clear any previously selected city when warehouse changes
          this.$set(this.formData, 'destination_city_id', '')
          // Store filtered cities in localStorage for persistence
          localStorage.setItem('city_list_by_warehouse', JSON.stringify(this.cityOptions))
        }
      } else {
        // Clear city options when no warehouse is selected and disable city dropdown
        const cityFormIndex = this.formStructure.findIndex(field => field.value === 'destination_city_id')
        if (cityFormIndex !== -1) {
          this.$set(this.formStructure[cityFormIndex], 'fetchData', [])
          this.$set(this.formStructure[cityFormIndex], 'disabled', true) // Disable city dropdown
          this.$set(this.formData, 'destination_city_id', '')
        }
        this.cityOptions = []
        localStorage.removeItem('city_list_by_warehouse')
      }
      this.updateDropdownOptions('destination_city_id', this.cityOptions || [])
      // Enable/disable city dropdown based on warehouse selection
      const cityFieldIndex = this.formStructure.findIndex(field => field.value === 'destination_city_id')
      if (cityFieldIndex !== -1) {
        this.$set(this.formStructure[cityFieldIndex], 'disabled', !warehouseId)
      }
    },
    updateDropdownOptions(fieldValue, data = [], fieldIndex = null) {
      const index = fieldIndex ?? this.formStructure.findIndex(field => field.value === fieldValue)
      if (index === -1) return

      const field = this.formStructure[index]
      const formattedOptions = this.formatDropdownOptions(data, field.fetchFilter)

      this.$set(this.formStructure[index], 'fetchData', data)
      this.$set(this.formStructure[index], 'options', formattedOptions)
    },
    formatDropdownOptions(data, fetchFilter) {
      if (fetchFilter && typeof fetchFilter === 'function') {
        return data.map(item => fetchFilter(item))
      }

      return data.map(item => ({
        label: item.name || item.label || String(item),
        value: item.id || item.value || item,
      }))
    },
    async getCityListByWarehouse(warehouseId) {
      try {
        const { data } = await ResourceRepository.getCityListByWarehouse(warehouseId)
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      return []
    },
    async onSubmit() {
      const truckDriverEnabled = localStorage.getItem('truck_driver_enabled')
      try {
        this.modalLoading = true
        const payload = {}
        if (!this.formData.driver_id) {
          this.formData.driver_id = null
        }
        payload.other_details = this.formData
        payload.waybill_numbers = [this.order.waybill_number]
        payload.status_key = this.nextStatusKey
        if (this.nextStatusKey === 'key_11') {
          payload.other_details.is_bulk = true
        }
        if (this.nextStatusKey === 'key_10') {
          payload.truck_driver = Boolean(!truckDriverEnabled) || this.orderSettings.truck_driver_enabled
        }
        await OrderRepository.updateOrderStatus(payload)
        this.modalLoading = false
        this.showSuccessMessage('Order updated successfully')
        this.open = false
        this.$parent.onClickRefresh()
      } catch (e) {
        this.modalLoading = false
        this.convertAndNotifyError(e)
      }
    },
    onModalHidden() {
      // Clear form structure and data when modal is closed
      this.formStructure = []
      this.formData = {}
      this.errors = []
      this.nextStatusKey = ''
      this.activeTab = 0
      this.shouldOpenStatusChangeTab = false
    },
    async getOrderEditLogTimeline() {
      try {
        const response = await OrderRepository.getOrderEditLogTimeline(this.id)
        const { data } = response
        if (data.success && data.data) {
          this.editLogTimelineData = data.data
        } else {
          this.editLogTimelineData = []
        }
      } catch (e) {
        this.editLogTimelineData = []
      }
    },
    openWithOrder(order, options = {}) {
      if (!order) return
      const id = order.id || order.order_id
      if (!id) return
      const modalOptions = {
        ...options,
        order,
      }
      this.openModal(id, modalOptions)
    },
  },
}
</script>

<style scoped>
@media (max-width: 769px) {
    .modal {
        width: 100%;
    }
}

.signature-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.signature {
    min-height: 150px;
    min-width: 150px;
}

.signature-button {
    margin: 1.75rem 0 0.25rem 0;
}

.view-sign-button {
    margin: 0 0 1.25rem 0;
}

h5 {
    color: #000000;
}

.order-status-name {
    color: white;
}

.text-container {
    max-width: 100%;
    /* Set your desired maximum width */
    word-wrap: break-word;
    /* Break long words to the next line */
    white-space: normal;
    /* Allow whitespace to wrap */
}

.date-container {
    text-align: right;
    margin-top: 7px;
}

.date-formats {
    font-size: 0.857rem;
    font-weight: 500;
}

.col-container {
    width: 100%;
    min-height: 100%;
}

.sub-title {
    font-size: large;
}

p {
    font-weight: bold;
}

.status-bar {
    padding: 1rem;
}

.col-container {
    position: relative;
}

.avatar-container {
    position: absolute;
    top: 0;
    right: 0;
    margin: 10px;
}

@media (max-width: 1200px) {
    .avatar-container {
        position: static;
        margin: 0;
    }
}

@media (max-width: 768px) {
    .status-bar {
        padding: 0.5rem;
    }

    .col-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    #modal-order-view {
        max-width: 100%;
        width: 100%;
    }

    .view-sign-button {
        display: block;
    }

    .date-container {
        text-align: left;
    }

    .mobile-column {
        width: 100% !important;
        margin-bottom: 1rem;
    }

    .avatar-container {
        justify-content: center;
        width: 100%;
    }
}

@media (min-width: 768px) and (max-width: 1024px) {
    .status-bar {
        padding: 0.5rem;
    }

    .col-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    #modal-order-view {
        max-width: 100%;
        width: 100%;
    }

    .view-sign-button {
        display: block;
    }

    .date-container {
        text-align: left;
    }

    .mobile-column {
        width: 100% !important;
        margin-bottom: 1rem;
    }

    .avatar-container {
        justify-content: center;
        width: 100%;
    }
}

.proof-image {
    width: 100%;
    max-height: 200px;
    object-fit: contain;
    border-radius: 4px;
    border: 1px solid #e9ecef;
    cursor: pointer;
    transition: transform 0.2s ease;
    background-color: #f8f9fa;
}

.proof-image:hover {
    transform: scale(1.02);
}

.status-button {
    border-radius: 5px;
    cursor: pointer;
}

.status-button:hover {
    transform: scale(1.02);
}

.status-button-icon-container {
    border-radius: 5px 0 0 5px;
    padding: 0.3rem 0.2rem;
}

.status-button-text {
    font-size: 0.85rem;
    font-weight: 500;
    padding: 0.3rem 0.2rem;
}
</style>
